export default {
  name: 'Regen Digital',
  domain: 'regen-digital',
  id: '62700ee569741e0001eabbf3',
  slug: 'regen-digital',
  path: '/regen-digital/',
  logo: '/partners/regen-digital/img/logo.png',
  themes: {
    light: {
      primary: '#7cb0d7',
      secondary: '#7cb0d7',
      accent: '#FF5722',
      error: '#f44336',
      warning: '#ffc107',
      info: '#7cb0d7',
      success: '#8bc34a',
      appbar: '#FFFFFF',
    },
  },
};
